import { render, staticRenderFns } from "./articleDetails_e.vue?vue&type=template&id=7a66704f&"
import script from "./articleDetails_e.vue?vue&type=script&lang=js&"
export * from "./articleDetails_e.vue?vue&type=script&lang=js&"
import style0 from "./articleDetails_e.vue?vue&type=style&index=0&id=7a66704f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports